import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchArticleInfosFournisseur } from 'store/articleGestion/articleGestionActions';
import { clearArticleGestionValue } from 'store/articleGestion/articlesGestionActions';

import DemandeInformationsAcheteurDialogContent from './DemandeInformationsAcheteurDialogContent';

class DemandeInformationsAcheteurDialogContentContainer extends React.Component {

    async componentDidMount() {
        await this.props.clearArticleGestionValue();
    }

    render() {
        const { onChange, action, fetchArticleInfosFournisseur, informations, emailPO } = this.props;

        return (
            <DemandeInformationsAcheteurDialogContent
                onChange={onChange}
                action={action}
                fetchInformations={fetchArticleInfosFournisseur}
                informations={informations}
                emailPO={emailPO}
            />
        );
    }
}

DemandeInformationsAcheteurDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    informations: state.articleGestion.details.infosFournisseur,
    emailPO: state.reclamation.details.item.piece ? state.reclamation.details.item.piece.emailPO : null
});

const mapDispatchToProps = dispatch => ({
    fetchArticleInfosFournisseur: (codeArticle) => dispatch(fetchArticleInfosFournisseur(codeArticle)),
    clearArticleGestionValue: () => dispatch(clearArticleGestionValue('addAction'))
});

export default connect(mapStateToProps, mapDispatchToProps)(DemandeInformationsAcheteurDialogContentContainer);